<template>

  <ToastDialog :title="toastTitle" :message="toastMessage" :error="toastError" />

  <!--<div v-if="isLoading" class="loading-overlay">
    <LoadingModal message="Invio in corso..." />
  </div>-->
  <div v-show="isLoading">
    <LoadingOverlay :show="isLoading" title="Invio in corso..." :message="loadingMessage" />
  </div>  

  <!-- Modale informativa iniziale -->
  <!--<SimpleModal v-model="showLandingModal" title="" :buttons="['Ho capito']" @chose="() => console.log('Popup chiuso')">
    <p>
      <i class="bi bi-exclamation-triangle-fill"></i><br>
      <strong>Attenzione! <br>E' possibile inviare un solo quesito alla volta.<br>
        Qualora vengano inseriti più quesiti in un'unica richiesta, verrà<br>
        preso in considerazione esclusivamente il primo.</strong>
    </p>
  </SimpleModal>-->

  <SimpleModal v-model="showLandingModal" title="" :buttons="['Ho capito']" @chose="() => console.log('Popup chiuso')">
    <p>
      <i class="bi bi-exclamation-triangle-fill"></i><br>
      <strong>Attenzione!</strong><br>È possibile effettuare un invio multiplo di quesiti in un’unica sessione<br>
        attraverso la funziona «Aggiungi nuovo».<br>
    </p>
  </SimpleModal>



  <SimpleModal v-model="showConfirmModal" title="Sei sicuro di voler procedere?" :buttons="['Modifica', 'Invia']"
    @chose="handleConfirmChoice" />
  <div class="question-view p-4">


    <!--<div class="d-flex justify-content-between align-items-center mb-4">
      <h1 class="mb-0">Nuovo Quesito</h1>
      <button class="btn btn-primary px-4" @click="saveQuestion" :disabled="!isFormValid">
        <i class="bi bi-floppy me-2"></i> Salva
      </button>
      <button class="btn btn-primary px-4" @click="saveQuestion" :disabled="!isFormValid">
        <i class="bi bi-envelope me-2"></i> Invia
      </button>
    </div>-->

    <div class="card p-4 mb-4">

      <!-- DIV Istruzioni -->
      <div class="mb-4 p-3"
        style="font-size: 0.9em; background-color: #fff; border: 0px solid #dee2e6; border-radius: 0.25rem; line-height: 1.2;">
        <p>
          Per l'invio dei quesiti al Servizio supporto giuridico l'utente deve compilare il campo
          <span class="fst-italic">"Oggetto"</span> posto in basso ed il campo
          <span class="fst-italic">"Testo del quesito"</span>, descrivendone sinteticamente il contenuto.
        </p>
        <p>
          Nel caso in cui il quesito riguardi tematiche afferenti appalti PNRR e PNC, flaggare l'apposita voce.
          Il sistema genera e assegna automaticamente al quesito un codice identificativo univoco.
          Le risposte ai quesiti elaborate dal Servizio saranno inoltrate all'indirizzo di posta elettronica che
          l'utente
          ha indicato in fase di registrazione.
        </p>
        <p>
          Le risposte verranno successivamente asseverate dall'Unità Operativa di Coordinamento (UOC), e pubblicate
          nell'apposita banca dati accessibile liberamente.
        </p>
        <p class="text-decoration-underline">
          Prima dell'asseverazione e successiva pubblicazione sulla piattaforma del Servizio, le risposte non rivestono
          carattere "ufficiale" e non possono essere considerate definitive. Pertanto,
          hanno carattere strettamente riservato, non possono essere utilizzate al di fuori del caso specifico oggetto
          del
          quesito, nè divulgate in alcuna forma prima della relativa pubblicazione.
        </p>
        <p>
          I quesiti, strettamente legati all'ambito applicativo del servizio, dovranno essere posti in maniera specifica
          e
          concisa, rispettando il limite dei 2000 caratteri. Le risposte mirano ad avere portata generale, si chiede
          pertanto agli utenti di non riportare dati riguardanti gli operatori economici coinvolti e/o riferimenti
          relativi alla specifica procedura di gara.
        </p>
        <p class="text-decoration-underline fw-bold">
          Gli utenti del Servizio sono responsabili della riservatezza del contenuto delle risposte.
        </p>
      </div>
    </div>

    <!-- Form Quesito -->
    <!--<form @submit.prevent="saveQuestion">-->
    <form>
      <div class="mb-3 row">
        <!--<div class="col-4">
          <label class="form-label">Argomenti</label>
          <template v-if="!readonly">
            <div class="dropdown">
              <button class="btn btn-light border text-dark w-100 d-flex justify-content-between align-items-center"
                type="button" data-bs-toggle="dropdown">
                <span>{{ selectedTopicsLabel }}</span>
              </button>

              <ul class="dropdown-menu p-2" style="max-height: 250px; overflow-y: auto; min-width: 250px;">
                <li class="mb-2 px-2">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text bg-white"><i class="bi bi-search"></i></span>
                    <input type="text" class="form-control" placeholder="Cerca..." v-model="topicSearch" />
                  </div>
                </li>

                <li v-for="topic in filteredTopics" :key="topic.id" class="form-check">
                  <input class="form-check-input" type="checkbox" :id="'topic-' + topic.id" :value="topic.id"
                    v-model="question.topics" />
                  <label class="form-check-label ms-2" :for="'topic-' + topic.id">{{ topic.title }}</label>
                </li>
              </ul>
            </div>
          </template>
<template v-else>
            <div class="mt-2">
              <span v-for="topicId in question.topics" :key="topicId" class="badge bg-secondary me-1">
                {{ getTopicName(topicId) }}
              </span>
            </div>
          </template>
<div class="mt-2 d-flex flex-column">
  <span v-for="(topicId, index) in question.topics" :key="topicId" class="badge bg-primary mb-1 align-self-start">
    {{ getTopicName(topicId) }}
    <button type="button" class="btn-close btn-close-white btn-sm ms-1" @click="removeTopic(index)"></button>
  </span>
</div>

</div>-->

        <!--<div class="col-4">
          <label class="form-label">Legislazione</label>
          <template v-if="!readonly">
            <div class="dropdown">
              <button class="btn btn-light border text-dark dropdown-toggle w-100 text-start" type="button"
                data-bs-toggle="dropdown">
                {{ selectedLegislationLabel }}
              </button>
              <ul class="dropdown-menu p-2" style="max-height: 250px; overflow-y: auto;">
                <li v-for="legislation in legislations" :key="legislation.id" class="form-check">
                  <input class="form-check-input" type="radio" :id="'legislation-' + legislation.id"
                    :value="legislation.id" v-model="question.legislation_id" />
                  <label class="form-check-label ms-2" :for="'legislation-' + legislation.id">
                    {{ legislation.title }}
                  </label>
                </li>
              </ul>
            </div>
          </template>
          <template v-else>
            <p class="form-control-plaintext">{{ getLegislationTitle(question.legislation_id) || '—' }}</p>
          </template>
        </div>-->

        <div class="col-4">
          <label class="form-label">Versione Codice dei Contratti Pubblici</label>

          <!-- Modalità modifica -->
          <template v-if="!readonly">
            <p class="form-control-plaintext fw-bold">
              {{ legislationLabel }}
            </p>
          </template>
          <!--<template v-if="!readonly">
            <select class="form-select" v-model="question.legislation_id" @change="onUserChangeLegislation">
              <option disabled value="">Seleziona Legislazione</option>
              <option v-for="leg in legislations" :key="leg.id" :value="leg.id">
                {{ leg.title }}
              </option>
            </select>
          </template>-->

          <!-- Modalità sola lettura -->
          <template v-else>
            <p class="form-control-plaintext fw-bold">
              {{ getLegislationTitle(question.legislation_id) || '—' }}
            </p>
          </template>
        </div>

        <!--<div class="col-4">
          <label class="form-label">Articolo</label>
          <template v-if="!readonly">
            <div class="dropdown">
              <button class="btn btn-light border text-dark dropdown-toggle w-100 text-start text-truncate"
                type="button" data-bs-toggle="dropdown" :title="selectedArticlesLabel">
                {{ selectedArticlesLabel }}
              </button>
              <ul class="dropdown-menu p-2" style="max-height: 250px; overflow-y: auto;">
                <li class="mb-2 px-2">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text bg-white"><i class="bi bi-search"></i></span>
                    <input type="text" class="form-control" placeholder="Cerca..." v-model="articleSearch" />
                  </div>
                </li>
                <li v-for="article in filteredArticles" :key="article.id" class="form-check">
                  <input class="form-check-input" type="checkbox" :id="'article-' + article.id" :value="article.id"
                    v-model="question.articles" />
                  <label class="form-check-label ms-2" :for="'article-' + article.id">{{ article.versions[0].title
                  }}</label>
                </li>
              </ul>

              <div class="mt-2 d-flex flex-column">
                <span v-for="(articleId, index) in question.articles" :key="articleId"
                  class="badge bg-primary mb-1 align-self-start badge-wrap">
                  {{ getArticleTitle(articleId) }}
                  <button type="button" class="btn-close btn-close-white btn-sm ms-1"
                    @click="removeArticle(index)"></button>
                </span>
              </div>
            </div>
          </template>
          <template v-else>
            <p class="form-control-plaintext">{{ selectedArticleLabel || '—' }}</p>
          </template>
        </div>-->

        <div v-if="!isOldLegislation" class="col-4">
          <label class="form-label">Articolo</label>
          <template v-if="!readonly">
            <div class="dropdown">
              <button class="btn btn-light border text-dark dropdown-toggle w-100 text-start text-truncate"
                type="button" data-bs-toggle="dropdown" :title="selectedArticlesLabel">
                {{ selectedArticlesLabel }}
              </button>
              <ul class="dropdown-menu p-2" style="max-height: 250px; overflow-y: auto;">
                <li class="mb-2 px-2">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text bg-white"><i class="bi bi-search"></i></span>
                    <input type="text" class="form-control" placeholder="Cerca..." v-model="articleSearch" />
                  </div>
                </li>
                <li v-for="article in filteredArticles" :key="article.id" class="form-check">
                  <input class="form-check-input" type="checkbox" :id="'article-' + article.id" :value="article.id"
                    v-model="question.articles" @click.stop />
                  <label class="form-check-label ms-2" :for="'article-' + article.id" @click.stop>{{
                    article.versions[0].title
                  }}</label>
                </li>
              </ul>

              <div class="mt-2 d-flex flex-column">
                <span v-for="(articleId, index) in question.articles" :key="articleId"
                  class="badge bg-primary mb-1 align-self-start badge-wrap">
                  {{ getArticleTitle(articleId) }}
                  <button type="button" class="btn-close btn-close-white btn-sm ms-1"
                    @click="removeArticle(index)"></button>
                </span>
              </div>
            </div>
          </template>
          <template v-else>
            <p class="form-control-plaintext">{{ selectedArticleLabel || '—' }}</p>
          </template>
        </div>
      </div>

      <!--<div class="mb-3">
        <template v-if="question.legislation_id">
          <label class="form-label fw-bold">Oggetto del quesito <small class="text-muted ms-2"
              style="font-size: 0.85em;">(max
              {{
                maxObjectLength }} caratteri)</small></label>
        </template>
        <template v-else>
          <label class="form-label fw-bold">Oggetto del quesito - indicare articolo di riferimento <small
              class="text-muted ms-2" style="font-size: 0.85em;">(max
              {{
                maxObjectLength }} caratteri)</small></label>
        </template>
        <template v-if="!readonly">
          <input type="text" class="form-control styled-input" v-model="question.object" :maxlength="maxObjectLength"
            placeholder="Inserisci l'oggetto" required />
          <small v-if="question.object.length > 0" class="text-muted d-block mt-1" style="font-size: 0.85em;">
            Caratteri rimanenti: {{ remainingObjectChars }}
          </small>
        </template>
        <template v-else>
          <p class="form-control-plaintext">{{ question.object }}</p>
        </template>
      </div>

      <div class="mb-3">
        <label class="form-label fw-bold">Testo del quesito <small class="text-muted ms-2 fs-7">
            (<strong>max {{ maxTextLength }} caratteri</strong>, quesiti di lunghezza superiore non saranno presi in
            considerazione)
          </small></label>
        <template v-if="!readonly">
          <textarea class="form-control styled-textarea" :class="{ 'text-area-scroll': question.text.length > 1000 }"
            v-model="question.text" :maxlength="maxTextLength" rows="8"
            placeholder="Inserisci il testo del quesito"></textarea>
          <small v-if="question.text.length > 0" class="text-muted d-block mt-1" style="font-size: 0.85em;">
            Caratteri rimanenti: {{ remainingTextChars }}
          </small>
        </template>
        <template v-else>
          <div class="p-2 border rounded bg-light" style="white-space: pre-wrap;">
            {{ question.text }}
          </div>
        </template>
      </div>-->


      <div v-for="(question, index) in questions" :key="index" class="card p-4 mb-4">
        <h5 class="mb-3">Quesito {{ index + 1 }}
        <button v-if="index > 0" type="button" class="btn btn-sm float-end"
          @click="removeQuestion(index)">
         <i class="bi bi-trash"></i>
        </button>

        </h5>



        <div class="mb-3">
          <template v-if="question.legislation_id">
            <label class="form-label fw-bold">
              Oggetto del quesito <small class="text-muted ms-2">(max {{ maxObjectLength }} caratteri)</small>
            </label>
          </template>
          <template v-else>
            <label class="form-label fw-bold">
              Oggetto del quesito - indicare articolo di riferimento <small class="text-muted ms-2">(max {{
                maxObjectLength }} caratteri)</small>
            </label>
          </template>
          <input type="text" class="form-control styled-input" v-model="question.object" :maxlength="maxObjectLength"
            placeholder="Inserisci l'oggetto" required />
          <small v-if="question.object.length > 0" class="text-muted d-block mt-1" style="font-size: 0.85em;">
            Caratteri rimanenti: {{ maxObjectLength - question.object.length }}
          </small>
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Testo del quesito <small class="text-muted ms-2 fs-7">
              (<strong>max {{ maxTextLength }} caratteri</strong>)
            </small></label>
          <textarea class="form-control styled-textarea" :class="{ 'text-area-scroll': question.text.length > 1000 }"
            v-model="question.text" :maxlength="maxTextLength" rows="8"
            placeholder="Inserisci il testo del quesito"></textarea>
          <small v-if="question.text.length > 0" class="text-muted d-block mt-1" style="font-size: 0.85em;">
            Caratteri rimanenti: {{ maxTextLength - question.text.length }}
          </small>
        </div>

      </div>

      <div class="mt-4 mb-3 text-start" style="font-size: .9em;">
        <p class="fw-bold">
          A seguito dell’invio del quesito l’utente riceverà al proprio indirizzo di posta elettronica
          una e-mail di conferma, con indicazione del relativo id assegnato.
        </p>
      </div>

      <!--<div class="d-flex justify-content-center gap-2 mt-4">
        <button type="button" class="btn btn-outline-primary me-2" @click="goBackToArticle">
          Indietro
        </button>

        <button type="button" class="btn btn-primary px-4" :disabled="!isFormValid" @click="showConfirmModal = true">
          <transition name="fade">
            <span v-if="isLoading" class="it-spinner it-spinner-sm me-2" role="status" aria-hidden="true"></span>
          </transition>
          Invia
        </button>
      </div>-->

      <div class="mb-4">
        <button type="button" class="btn btn-primary px-4" :disabled="!isCurrentQuestionValid"
          @click="addQuestion">
          <span class="rounded-circle border me-2 px-2">+</span>
          Aggiungi un altro quesito
        </button>
      </div>

      <div class="d-flex justify-content-center gap-2 mt-4">
        <button type="button" class="btn btn-outline-primary me-2" @click="goBackToArticle">
          Indietro
        </button>

        <button type="button" class="btn btn-primary px-4" :disabled="!isCurrentQuestionValid"
          @click="showConfirmModal = true">
          <transition name="fade">
            <span v-if="isLoading" class="it-spinner it-spinner-sm me-2" role="status" aria-hidden="true"></span>
          </transition>
          Invia
        </button>
      </div>

      <!--<div class="mb-3">
        <label class="form-label d-block mb-2">Commenti</label>

        <div v-for="(comment, index) in question.comments" :key="index" class="input-group mb-2">
          <input type="text" class="form-control" v-model="question.comments[index]" placeholder="Commento" />
          <button class="btn btn-outline-danger" type="button" @click="removeComment(index)">
            ✖
          </button>
        </div>

        <button class="btn btn-primary mt-2" type="button" @click="addComment">
          + Aggiungi commento
        </button>
      </div>-->
    </form>

  </div>
</template>

<script>
import ToastDialog from '../../../components/common/ToastDialog.vue';
import BreadcrumbElement from '../../../components/common/BreadcrumbElement.vue';
import ModalView from '../../../components/common/ModalView.vue';
import toastable from '../../../mixins/toastable';
import SimpleModal from '../../../components/common/SimpleModal.vue';
import LoadingModal from '../../partials/LoadingModal.vue';
import LoadingOverlay from '../../partials/LoadingOverlay.vue';

export default {
  name: 'QuestionView',
  mixins: [toastable],
  components: {
    ToastDialog,
    BreadcrumbElement,
    ModalView,
    SimpleModal,
    LoadingModal,
    LoadingOverlay
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      question: {
        object: '',
        text: '',
        comments: [],
        topics: [],
        //legislation_id: null,
        legislation_id: 1,
        articles: []
      },
      questions: [this.emptyQuestion()],
      legislations: [],
      maxObjectLength: 120,
      maxTextLength: 1500,
      showSuccessModal: false,
      toastTitle: '',
      toastMessage: '',
      toastError: false,
      errors: null,
      successMessage: null,
      availableTopics: [],
      availableArticles: [],
      topicSearch: '',
      articleSearch: '',
      articleGoBack: null,
      versionGoBack: null,
      showLandingModal: true,
      showConfirmModal: false,
      showSentModal: false,
      isLoading: false,
      legislationFromQuery: null,
      isInitialLoad: true,
      versionParam: null,
      sharedArticles: []
    };
  },
  methods: {
    removeQuestion(index) {
      this.questions.splice(index, 1);
    },
    emptyQuestion() {
      return {
        object: '',
        text: '',
        comments: [],
        topics: [],
        legislation_id: 1,
        articles: []
      };
    },
    addQuestion() {
      this.questions.push(this.emptyQuestion());
      this.$nextTick(() => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
      });
    },
    onUserChangeLegislation() {
      this.question.articles = [];
    },
    filterVersionsByDate(article, dateStr) {
      const date = new Date(dateStr);

      const validVersions = article.versions.filter(v => {
        const begin = new Date(v.version.begin);
        const end = v.version.end ? new Date(v.version.end) : null;


        if (end) {
          return date >= begin && date <= end;
        }

        return date >= begin;
      });

      return validVersions;
    },

    filterArticlesByLegislationDate(allArticles, legislation, searchDate = null) {
      const activeDate = searchDate ? new Date(searchDate) : new Date();

      return allArticles
        .map(article => {
          const allVersions = article.versions.map(v => ({ ...v.version, frontendVersionId: v.id }));

          // Filtra le versioni attive
          let activeVersions = allVersions.filter(v => {
            const begin = new Date(v.begin);
            const end = v.end ? new Date(v.end) : null;
            if (end) return activeDate >= begin && activeDate <= end;
            return activeDate >= begin;
          });

          // Se non ci sono versioni attive, usa comunque la prima versione per replica backend
          if (activeVersions.length === 0 && allVersions.length > 0) {
            const sortedByBeginDesc = allVersions.sort((a, b) => new Date(b.begin) - new Date(a.begin));
            activeVersions = [sortedByBeginDesc[0]];
          }

          let filteredVersions = activeVersions;

          if (activeVersions.length > 1) {
            const mainVersion = activeVersions.find(v => {
              const begin = new Date(v.begin);
              const end = v.end ? new Date(v.end) : null;
              return (!end && begin <= activeDate) || (end && begin <= activeDate && end >= activeDate);
            }) || activeVersions[0];

            filteredVersions = activeVersions.filter(v => v.title === mainVersion.title);
          }

          const finalVersions = article.versions.filter(av =>
            filteredVersions.some(fv => fv.id === av.version.id)
          );

          return { ...article, versions: finalVersions };
        })
        .filter(article => article.versions.length > 0)
        .sort((a, b) => a.id - b.id);
    }

    ,
    handleConfirmChoice(option) {
      if (option === 'Invia') {
        this.isLoading = true;
        this.$nextTick(() => {
          this.confirmSendQuestion();
        });
      } else {
        this.showConfirmModal = false;
      }
    },
    confirmSendQuestion() {
      this.showConfirmModal = false;
      this.saveQuestion().finally(() => {
        this.isLoading = false;
      });
    },
    redirectToList() {
      this.showSentModal = false;
      this.$router.push('/questions');
    },
    goBackToArticle() {
      const articleId = this.articleGoBack;
      const version = this.versionGoBack;

      if (!articleId) {
        console.warn("Nessun articleId trovato nella query.");
        this.$emit('change-view', 'QuestionsByTopicsView')
        return;
      }

      // Vai alla rotta dell’articolo
      this.$router.push(`/article/${articleId}${version ? '/' + version : ''}`);
    },
    extractAllArticlesFromTree() {
      const all = this.$root.contents?.articles || {};

      return Object.values(all)
        .filter(a => !a.deleted_at && a.versions && a.versions.length > 0)
        .map(a => ({
          id: a.id,
          versions: a.versions
        }));
    },
    getLegislationName(id) {
      const legislation = this.legislations.find(l => l.id === id);
      return legislation ? legislation.title : '';
    },
    addComment() {
      this.question.comments.push('');
    },
    removeComment(index) {
      this.question.comments.splice(index, 1);
    },
    async saveQuestion() {
      try {
        const token = localStorage.getItem('token');

        this.question.legislation_id =
          this.versionParam === null || this.versionParam === undefined
            ? null
            : 1;

        const questionPayload = { ...this.question };
        if (this.question.legislation_id === 0) {
          questionPayload.articles = null;
        }

        this.questions.forEach(q => {
          q.legislation_id = (this.versionParam === null || this.versionParam === undefined) ? null : 1;
          if (q.legislation_id === 0) {
            q.articles = null;
          }
        });

        //const payload = { questions: this.questions };
        const payload = {
          questions: this.questions.map(q => ({
            ...q,
            articles: [...this.question.articles]
          }))
        };

        const url = new URL(`${this.$root.config.VITE_APP_BACKOFFICE_URL}/questions/store`);

        const response = await fetch(url.toString(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
          },
          //credentials: 'include', 
          //body: JSON.stringify(questionPayload)
          body: JSON.stringify(payload)
        });

        const data = await response.json();
        data.isSuccess = response.ok;
        data.status = response.status;

        if (data.isSuccess) {
          console.log('Quesito creato con successo:', data);
          this.showSuccessToast('Complimenti', 'Quesito creato con successo');

          await this.$router.push({ path: '/questions', query: { inviato: 'true' } });


        } else {
          console.error('Errore nella creazione del quesito:', data);
          this.showErrorToast('Errore', 'Errore nel salvataggio del quesito');
          this.errors = data.errors || { general: ['Si è verificato un errore durante la creazione del quesito'] };
        }

      } catch (error) {
        console.error('Errore imprevisto:', error);
        this.showErrorToast('Errore', 'Errore nel salvataggio del quesito');
        this.errors = { general: ['Si è verificato un errore durante la creazione del quesito'] };
      }
    }
    ,
    addTopic(event) {
      const id = parseInt(event.target.value);
      if (id && !this.question.topics.includes(id)) {
        this.question.topics.push(id);
      }
      event.target.value = ''; // reset select
    },
    removeTopic(index) {
      this.question.topics.splice(index, 1);
    },
    getTopicName(id) {
      const topic = this.availableTopics.find(t => t.id === id);
      return topic ? topic.title : '';
    },
    getArticleTitle(id) {
      const art = this.availableArticles.find(a => a.id === id);
      return art ? art.versions[0].title : `Articolo ${id}`;
    },
    removeArticle(index) {
      this.question.articles.splice(index, 1);
    }
  },
  /**watch: {
    'question.legislation_id': async function (newLegId) {
      this.question.articles = [];
      if (!newLegId) {
        this.availableArticles = [];
        return;
      }
  
      try {
        const response = await this.$root.$api.get('/articles/bylegislation', {
          params: { legislation_id: newLegId }
        });
        this.availableArticles = response.data;
      } catch (error) {
        this.showErrorToast('Errore', 'Impossibile caricare articoli per la legislazione selezionata');
      }
    }
  },*/
  /**watch: {
    'question.legislation_id'(newValue) {
      if (!newValue) return;

      this.question.articles = [];

      // Se hai API che filtrano articoli per legislazione → ricarica qui
      // oppure usa il tuo metodo local: extractAllArticlesFromTree()

      this.availableArticles = this.extractAllArticlesFromTree()
        .filter(a => a.versions.some(v => v.version.id === newValue))
        .sort((a, b) => a.id - b.id);
    }
  },*/
  watch: {
    'question.legislation_id': function (newValue, oldValue) {
      if (!newValue) {
        this.availableArticles = [];
        return;
      }

      const legislation = this.legislations[newValue];

      if (!this.isInitialLoad) {
        this.question.articles = [];
      }

      //this.question.articles = [];

      // prendi tutti gli articoli dal tree
      const allArticles = this.extractAllArticlesFromTree();

      // applica filtro per data
      this.availableArticles = this.filterArticlesByLegislationDate(allArticles, legislation);

      // ordina per id articolo
      this.availableArticles.sort((a, b) => a.id - b.id);
    }
  },
  computed: {
    currentQuestion() {
      return this.questions[this.questions.length - 1];
    },
    isCurrentQuestionValid() {
      const q = this.currentQuestion;
      return q.object.trim().length > 0 && q.text.trim().length > 0;
    },
    legislationLabel() {
      if (this.versionParam === null || this.versionParam === undefined) {
        return "d.lgs 50/2016";
      }
      return "versione vigente del Codice dei Contratti Pubblici";
    },
    isOldLegislation() {
      return this.versionParam === null || this.versionParam === undefined;
    },
    remainingObjectChars() {
      return this.maxObjectLength - (this.question.object?.length || 0);
    },
    remainingTextChars() {
      return this.maxTextLength - (this.question.text?.length || 0);
    },
    selectedTopicsLabel() {
      if (this.question.topics.length === 0) return 'Seleziona argomenti';
      if (this.question.topics.length === 1) {
        const topic = this.availableTopics.find(t => t.id === this.question.topics[0]);
        return topic ? topic.title : '1 argomento';
      }
      return `Selezione multipla (${this.question.topics.length})`;
    },
    isFormValid() {
      const isLegislationActive = this.question.legislation_id === 1;
      return (
        this.question.object.trim().length > 0 &&
        this.question.text.trim().length > 0 &&
        (
          !isLegislationActive ||
          (isLegislationActive && this.question.articles.length > 0)
        )
      );
    },
    selectedLegislationLabel() {
      if (!this.question.legislation_id) return 'Seleziona legislazione';
      const leg = this.legislations.find(l => l.id === this.question.legislation_id);
      return leg ? leg.title : 'Seleziona legislazione';
    },
    selectedArticlesLabel() {
      if (!this.question.articles || this.question.articles.length === 0) return 'Seleziona articoli';
      if (this.question.articles.length === 1) {
        const art = this.availableArticles.find(a => a.id === this.question.articles[0]);
        return art ? art.versions[0].title : '1 articolo';
      }
      return `Selezione multipla (${this.question.articles.length})`;
    },
    filteredTopics() {
      if (!this.topicSearch) return this.availableTopics;
      return this.availableTopics.filter(t =>
        t.title.toLowerCase().includes(this.topicSearch.toLowerCase())
      );
    },
    filteredArticles() {
      if (!this.articleSearch) return this.availableArticles;
      return this.availableArticles.filter(a =>
        a.versions[0].title.toLowerCase().includes(this.articleSearch.toLowerCase())
      );
    }
  },
  async mounted() {
    /**try {
      const response = await this.$root.$api.get('/questions/topics');
      this.availableTopics = response.data;
    } catch (error) {
      this.showErrorToast('Errore', 'Impossibile caricare gli argomenti');
    }*/

    this.versionParam = this.$route.query.version;

    this.availableArticles = this.extractAllArticlesFromTree()
      .sort((a, b) => a.id - b.id); // ordina per id crescente
    console.log("Articoli caricati:", this.availableArticles);
    console.log("Articoli caricati:", this.availableArticles);

    const articleFromQuery = this.$route.query.article;
    this.articleGoBack = articleFromQuery;

    const versionFromQuery = this.$route.query.activeVersionId;
    this.versionGoBack = versionFromQuery;

    this.legislationFromQuery = this.$route.query.version;

    if (articleFromQuery) {
      this.question.articles = [parseInt(articleFromQuery)];
    }

    try {
      const [topicsResponse, legislationsResponse] = await Promise.all([
        this.$root.$api.get('/questions/topics'),
        //this.$root.$api.get('/questions/legislations'),
      ]);

      this.availableTopics = topicsResponse.data;
      //this.legislations = legislationsResponse.data;
      this.legislations = Object.values(this.$root.dlgs || {});


    } catch (error) {
      this.showErrorToast('Errore', 'Impossibile caricare argomenti o legislazioni');
    }
    if (this.legislationFromQuery) {
      this.question.legislation_id = parseInt(this.legislationFromQuery);
    } else {
      this.question.legislation_id = "";
    }
    this.isInitialLoad = true;

  }

};
</script>

<style scoped>
.question-view {
  padding: 2rem;
}

.card {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(74, 108, 247, 0.15);
}

.input-group input {
  flex: 1;
}

.text-area-scroll {
  min-height: 200px;
  max-height: 400px;
  overflow-y: auto;
  resize: vertical;
  line-height: 1.4;
  white-space: pre-wrap;
}

.badge-wrap {
  white-space: normal;
  word-break: break-word;
  display: inline-block;
  max-width: 100%;
}

/* Dropdown Bootstrap Italia personalizzata */
.dropdown .btn {
  background-color: #fff !important;
  border-color: #ccc !important;
  font-size: 0.9rem;
  padding: 0.45rem 0.6rem;
}

/* Menu dropdown */
.dropdown-menu {
  background: #fff !important;
  font-size: 0.85rem;
}

/* Elementi checkbox dentro dropdown */
.dropdown-menu .form-check-label {
  font-size: 0.85rem;
}

.dropdown-menu .form-check-input {
  margin-top: 0.2rem;
}

.styled-input,
.styled-textarea {
  border: 2px solid #4a6cf7;
  border-radius: 0.5rem;
  padding: 0.75rem;
  background-color: #f8f9ff;
  font-size: 1rem;
  transition: all 0.2s ease-in-out;
}

.styled-input:focus,
.styled-textarea:focus {
  outline: none;
  border-color: #3650d1;
  box-shadow: 0 0 8px rgba(74, 108, 247, 0.5);
  background-color: #ffffff;
}

.styled-textarea {
  min-height: 150px;
  max-height: 400px;
  resize: vertical;
  line-height: 1.5;
  white-space: pre-wrap;
}

.styled-readonly {
  background-color: #f1f3f8;
  border: 1px solid #dcdfe6;
  border-radius: 0.5rem;
  padding: 0.75rem;
  min-height: 80px;
  white-space: pre-wrap;
}

.char-counter {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.85rem;
  color: #6c757d;
  text-align: right;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.8);
  /* opzionale per un leggero effetto pop */
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  transform: scale(1);
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.loading-overlay {
  position: fixed;
  /* Copre tutta la finestra */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  /* Semi-trasparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  /* Deve essere sopra tutto */
  overflow: hidden;
  /* Previene scroll */
}

.loading-overlay>* {
  animation: fadeIn 0.2s ease-in-out;
  /* optional fade-in del modal */
}
</style>